"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelimiterType = exports.PricingType = void 0;
var PricingType;
(function (PricingType) {
    PricingType["LARGE"] = "large";
    PricingType["MEDIUM"] = "medium";
    PricingType["SMALL"] = "small";
    PricingType["XSMALL"] = "xsmall";
    PricingType["SMALL2"] = "small2";
    PricingType["CART"] = "cart";
    PricingType["TILE"] = "tile";
    PricingType["FEATURED"] = "featured";
    PricingType["DUETODAY"] = "duetoday";
    PricingType["PERMONTH"] = "permonth";
    PricingType["DUEFIRSTMONTH"] = "firstmonth";
    PricingType["REWARDCARDTOTAL"] = "rewardcardtotal";
})(PricingType = exports.PricingType || (exports.PricingType = {}));
var DelimiterType;
(function (DelimiterType) {
    DelimiterType["SLASH"] = "/";
    DelimiterType["SPACE"] = " ";
})(DelimiterType = exports.DelimiterType || (exports.DelimiterType = {}));
//# sourceMappingURL=PriceContainerProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/PriceContainer/PriceContainerProps.js
// module id = 27
// module chunks = 8